const seniorSecondaryBoards = {
  CBSE: {
    "Science (with Maths)": [
      "Physics",
      "Chemistry",
      "English",
      "Mathematics",
      "Computer Science",
      "Informatics Practices",
      "Physical Education",
      "Psychology",
      "Economics",
      "Biotechnology",
      "Engineering Drawing",
    ],
    "Science (with Biology)": [
      "Physics",
      "Chemistry",
      "English",
      "Biology",
      "Computer Science",
      "Informatics Practices",
      "Physical Education",
      "Psychology",
      "Economics",
      "Biotechnology",
      "Engineering Drawing",
    ],
    "Science (with both Maths and Biology)": [
      "Physics",
      "Chemistry",
      "English",
      "Mathematics",
      "Biology",
      "Computer Science",
      "Informatics Practices",
      "Physical Education",
      "Psychology",
      "Economics",
      "Biotechnology",
      "Engineering Drawing",
    ],
    Commerce: [
      "Accountancy",
      "Business Studies",
      "Economics",
      "English",
      "Mathematics",
      "Informatics Practices",
      "Entrepreneurship",
      "Physical Education",
    ],
    Arts: [
      "English",
      "Regional Languages",
      "Fine Arts",
      "Music",
      "Dance",
      "Theatre Studies / Drama",
      "Physical Education",
      "Home Science",
      "Media Studies / Mass Communication",
      "Fashion Studies",
    ],
    Humanities: [
      "English",
      "History",
      "Political Science",
      "Geography",
      "Economics",
      "Sociology",
      "Psychology",
      "Legal Studies",
      "Philosophy",
      "Anthropology",
      "Physical Education",
      "Home Science",
      "Mathematics",
    ],
    "Vocational/Skill-Based": [
      "Entrepreneurship",
      "Informatics Practices",
      "Web Design",
      "Information Technology (IT)",
      "Retail Management",
      "Automotive",
      "Beauty and Wellness",
      "Fashion Studies",
    ],
  },

  "CISCE (ICSE/ISC)": {
    Science: [
      "Physics",
      "Chemistry",
      "Biology",
      "Biotechnology",
      "Electricity & Electronics",
      "Mathematics",
    ],
    Commerce: [
      "Accountancy",
      "Business Studies",
      "Commerce",
      "Economics",
      "Mathematics",
    ],
    Humanities: [
      "English",
      "History",
      "Political Science",
      "Sociology",
      "Geography",
      "Psychology",
      "Legal Studies",
      "Home Science",
      "Environmental Science",
      "Mass Media & Management",
      "Indian Languages",
    ],
  },

  NIOS: {
    Science: [
      "Physics",
      "Chemistry",
      "Mathematics",
      "Biology",
      "Computer Science",
      "Economics",
      "English",
      "Hindi",
    ],
    Commerce: [
      "Accountancy",
      "Business Studies",
      "Economics",
      "Mathematics",
      "Computer Science",
      "English",
      "Hindi",
    ],
    "Arts/Humanities": [
      "History",
      "Geography",
      "Political Science",
      "Sociology",
      "Psychology",
      "Economics",
      "English",
      "Hindi",
    ],
    Vocational: [
      "Information Technology (IT)",
      "Health",
      "Nutrition",
      "Fashion Design",
      "Painting",
      "Multimedia",
    ],
  },
  "CAIE (IGCSE / AS & A Levels)": {
    "Subject-based (AS & A Levels)": [
      "Physics",
      "Chemistry",
      "Biology",
      "Business",
      "Economics",
      "Accounting",
      "English Literature",
      "Languages",
      "History",
      "Geography",
      "Politics",
      "Philosophy",
      "Psychology",
      "Religious Studies",
      "Computer Science",
      "Information & Communication Technology (ICT)",
      "Art",
      "Photography",
      "Performing Arts",
      "Travel & Tourism",
      "Media Studies",
      "Further Mathematics",
    ],
  },

  "IB (MYP / DP)": {
    "Group 1: Studies in Language and Literature": [
      "Language A: Literature",
      "Language A: Language and Literature",
      "Literature and Performance",
    ],
    "Group 2: Language Acquisition": [
      "Classical Languages",
      "Language Ab Initio",
      "Language B",
    ],
    "Group 3: Individuals and Societies": [
      "Business Management",
      "Digital Society",
      "Economics",
      "Geography",
      "Global Politics",
      "History",
      "Philosophy",
      "Psychology",
      "Social and Cultural Anthropology",
      "World Religions",
    ],
    "Group 4: Sciences": [
      "Biology",
      "Chemistry",
      "Computer Science",
      "Design Technology",
      "Environmental Systems and Societies",
      "Physics",
      "Sports, Exercise and Health Science",
    ],
    "Group 5: Mathematics": [
      "Analysis and Approaches (SL/HL)",
      "Applications and Interpretation (SL/HL)",
    ],
    "Group 6: The Arts": ["Dance", "Film", "Music", "Theatre", "Visual Arts"],
    "DP Core": [
      "Creativity, Activity, Service (CAS)",
      "Extended Essay (EE)",
      "Theory of Knowledge (TOK)",
    ],
  },

  "Andhra Pradesh - BSEAP": {
    Science: [
      "Physics",
      "Chemistry",
      "Mathematics",
      "Biology (Botany, Zoology)",
    ],
    Commerce: ["Commerce", "Economics"],
    "Arts/Humanities": [
      "History",
      "Political Science",
      "Sociology",
      "Civics",
      "Public Administration",
      "Logic",
      "Geography",
      "Modern Languages",
    ],
  },

  "Assam - AHSEC": {
    Science: [
      "English",
      "Physics",
      "Chemistry",
      "Mathematics",
      "Biology (Botany, Zoology)",
      "Computer Science & Application",
      "Biotechnology",
    ],
    Commerce: [
      "English",
      "Accountancy",
      "Business Studies",
      "Economics",
      "Statistics",
      "Business Mathematics & Statistics",
    ],
    "Arts/Humanities": [
      "English",
      "Education",
      "Economics",
      "Political Science",
      "History",
      "Geography",
      "Sociology",
      "Psychology",
      "Alternative English",
      "Finance",
      "Anthropology",
    ],
  },

  "Bihar - BSEB": {
    Science: [
      "Physics",
      "Chemistry",
      "Biology",
      "Mathematics",
      "Computer Science",
      "English",
      "Hindi",
      "Agriculture",
    ],
    Commerce: [
      "Accountancy",
      "Business Studies",
      "Economics",
      "Mathematics",
      "English",
      "Hindi",
    ],
    "Arts/Humanities": [
      "Political Science",
      "History",
      "Geography",
      "Economics",
      "Psychology",
      "Sociology",
      "English",
      "Hindi",
      "Home Science",
      "Physical Education",
    ],
  },

  "Chhattisgarh - CGBSE": {
    Science: ["Physics", "Chemistry", "Mathematics", "Biology"],
    Commerce: ["Accountancy", "Business Studies", "Economics"],
    "Arts/Humanities": [
      "History",
      "Geography",
      "Political Science",
      "Economics",
      "Psychology",
      "Sociology",
      "English",
      "Hindi",
      "Urdu",
      "Sanskrit",
    ],
  },

  "Goa - GBSHSE": {
    Science: [
      "English",
      "Mathematics",
      "Physics",
      "Chemistry",
      "Biology",
      "Computer Science",
    ],
    Commerce: [
      "English",
      "Accountancy",
      "Banking",
      "Business Studies",
      "Economics",
      "Mathematics",
    ],
    "Arts/Humanities": [
      "English",
      "Marathi",
      "Hindi",
      "Sanskrit",
      "Urdu",
      "Portuguese",
      "History",
      "Economics",
      "Political Science",
      "Psychology",
      "Sociology",
      "Logic",
      "Geography",
    ],
  },

  "Gujarat - GSEB": {
    Science: ["Mathematics", "Physics", "Chemistry", "Biology", "English"],
    "General (Commerce/Arts)": [
      "English",
      "Hindi",
      "Gujarati",
      "Economics",
      "Statistics",
      "Political Science",
      "Geography",
      "History",
    ],
  },

  "Haryana - HBSE": {
    Science: [
      "Physics",
      "Chemistry",
      "Mathematics",
      "Biology",
      "Computer Science",
      "English Core",
      "English Elective",
      "Hindi Aadhar",
      "Hindi Elective",
      "Sanskrit",
      "Punjabi",
      "Urdu",
    ],
    Commerce: [
      "Accountancy",
      "Business Studies",
      "Economics",
      "Mathematics",
      "English Core",
      "English Elective",
      "Hindi Aadhar",
      "Hindi Elective",
      "Entrepreneurship",
    ],
    "Arts/Humanities": [
      "History",
      "Political Science",
      "Sociology",
      "Geography",
      "Economics",
      "Psychology",
      "Philosophy",
      "Fine Art",
      "Home Science",
      "Physical Education",
      "Public Administration",
      "Agriculture",
      "Military Science",
      "English Core",
      "English Elective",
      "Hindi Aadhar",
      "Hindi Elective",
      "Sanskrit",
      "Punjabi",
      "Urdu",
    ],
  },

  "Jammu & Kashmir - JKBOSE": {
    Science: [
      "Physics",
      "Chemistry",
      "Biology",
      "Mathematics",
      "Computer Science",
      "Environmental Science",
      "English",
      "Hindi",
      "Urdu",
      "Agriculture",
    ],
    Commerce: ["Business Studies", "Accountancy", "Business Mathematics"],
    Humanities: [
      "General English",
      "Philosophy",
      "History",
      "Geography",
      "Psychology",
      "Sociology",
    ],
    "Home Science": [
      "Human Development",
      "Extension Education",
      "Food Technology",
    ],
  },

  "Jharkhand - JAC": {
    Science: [
      "Physics",
      "Chemistry",
      "Mathematics",
      "Biology",
      "Computer Science",
      "Core Language (English/Hindi)",
    ],
    Commerce: [
      "Accountancy",
      "Business Studies",
      "Core Language (English/Hindi)",
    ],
    "Arts/Humanities": [
      "Core Language (English/Hindi)",
      "Optional Subject 1",
      "Optional Subject 2",
      "Optional Subject 3",
      "Elective Language",
    ],
  },

  "Karnataka - KSEEB/KSEAB (PUC)": {
    Science: [
      "Physics",
      "Chemistry",
      "Biology",
      "Mathematics",
      "Computer Science",
      "Electronics",
      "English",
      "Kannada",
      "Hindi",
      "Sanskrit",
      "Marathi",
      "Urdu",
      "French",
    ],
    Commerce: ["Economics", "Business Studies", "Accountancy"],
    Arts: [
      "Economics",
      "Political Science",
      "English",
      "History",
      "Geography",
      "Psychology",
      "Sociology",
      "Logic",
      "Music",
      "Home Science",
      "Physical Education",
      "Public Administration",
      "Fine Arts",
      "Languages",
    ],
  },

  "Kerala - KBPE (Plus One/Plus Two)": {
    Science: [
      "Physics",
      "Chemistry",
      "Biology",
      "Mathematics",
      "Computer Science",
      "English",
    ],
    Commerce: [
      "Accountancy",
      "Business Studies",
      "Economics",
      "Statistics",
      "Computer Science",
      "English",
    ],
    "Arts/Humanities": [
      "History",
      "Political Science",
      "Economics",
      "Geography",
      "Sociology",
      "Psychology",
      "English",
    ],
  },

  "Madhya Pradesh - MPBSE": {
    Arts: [
      "History",
      "Political Science",
      "Geography",
      "Economics",
      "Indian Music",
      "Dancing",
      "Drawing and Designing",
      "Psychology",
      "Home Science",
      "Anatomy, Physiology and Hygiene",
      "Sociology",
      "Agriculture",
    ],
    Science: [
      "Mathematics",
      "Physics",
      "Chemistry",
      "Biology",
      "Geology",
      "Forestry",
    ],
    Commerce: [
      "Elements of Commerce and Banking",
      "Book-keeping and Accountancy",
      "Applied Economics and Commercial Geography",
      "Industrial Organisation",
      "Business Mathematics",
      "Computer Application",
      "Steno-typing",
    ],
    Agriculture: [
      "Elements of Science and Mathematics",
      "Crop Production and Horticulture",
      "Elements of Animal Husbandry and Poultry Farming",
    ],
    "Fine Arts": [
      "Drawing and Painting",
      "Arts & Craft",
      "History of Indian Art & World Art",
    ],
    "Home Science": [
      "Elements of Science",
      "Mother-craft",
      "Health and Hygiene",
      "Home-management & Nutrition",
    ],
    Technical: [
      "Engineering Science",
      "Engineering Drawing",
      "Workshop Practice",
    ],
  },

  "Maharashtra - MSBSHSE": {
    Science: [
      "Physics",
      "Chemistry",
      "Biology",
      "Mathematics",
      "Information Technology",
    ],
    Commerce: [
      "Accountancy",
      "Business Studies",
      "Economics",
      "Mathematics & Statistics",
      "Organisation of Commerce & Management",
      "Secretarial Practice",
      "Information Technology",
    ],
    Arts: [
      "History",
      "Political Science",
      "Geography",
      "Psychology",
      "Sociology",
      "Economics",
      "English",
      "Marathi",
      "Hindi",
      "Philosophy",
      "Logic",
      "Education",
      "Home Management",
      "Textiles",
    ],
    Vocational: [
      "Computer Science (Programming in Python, Database Management)",
      "Tourism & Hospitality (Travel and Tourism Industry, Customer Relations)",
      "Agriculture Science (Soil Management, Crop Production)",
      "Health Care (Anatomy, First Aid, Nursing)",
    ],
  },

  "Manipur - BSEM": {
    Science: [
      "Physics",
      "Chemistry",
      "Mathematics",
      "Biology (Botany, Zoology)",
    ],
    Commerce: ["Accountancy", "Economics", "Business Studies"],
    Arts: ["History", "Geography", "Political Science", "English"],
  },

  "Meghalaya - MBOSE": {
    Science: ["Physics", "Chemistry", "Biology", "Mathematics"],
    Commerce: ["Accountancy", "Business Studies", "Economics"],
    Arts: [
      "English",
      "Assamese Elective/MIL",
      "Bengali Elective/MIL",
      "Garo Elective/MIL",
      "Hindi Elective/MIL",
      "Khasi Elective/MIL",
      "Mizo Elective/MIL",
      "Nepali Elective/MIL",
      "Education",
      "Philosophy",
      "Statistics",
      "Geography",
    ],
    Vocational: ["Vocational Subjects"],
  },

  "Mizoram - MBSE": {
    Arts: [
      "History",
      "Geography",
      "Education",
      "Economics",
      "Political Science",
      "Mathematics",
      "Home Science",
      "Psychology",
      "Sociology",
      "Public Administration",
      "Computer Science",
      "English",
      "Mizo",
      "Hindi",
      "Bengali",
      "Nepali",
    ],
    Science: [
      "Biology",
      "Physics",
      "Chemistry",
      "Computer Science",
      "Home Science",
      "Geology",
      "Mathematics",
      "English",
      "Mizo",
      "Hindi",
      "Bengali",
      "Nepali",
    ],
    Commerce: [
      "Business Studies",
      "Economics",
      "Accountancy",
      "Business Mathematics",
      "English",
      "Mizo",
      "Hindi",
      "Bengali",
      "Nepali",
    ],
  },

  "Nagaland - NBSE": {
    Science: ["Physics", "Chemistry", "Mathematics", "Biology"],
    Commerce: ["Accountancy", "Business Studies", "Economics"],
    Arts: [
      "History",
      "Political Science",
      "Sociology",
      "Geography",
      "Psychology",
    ],
  },

  "Odisha - BSE Odisha (CHSE)": {
    Science: ["Physics", "Chemistry", "Mathematics", "Biology"],
    Commerce: ["Accountancy", "Business Studies", "Economics"],
    Arts: [
      "History",
      "Political Science",
      "Economics",
      "Geography",
      "Sociology",
    ],
    Vocational: ["Vocational Subjects"],
  },

  "Punjab - PSEB": {
    Science: ["Physics", "Chemistry", "Mathematics", "Biology"],
    Commerce: ["Accountancy", "Business Studies", "Economics"],
    Arts: ["History", "Political Science", "Geography"],
  },

  "Rajasthan - RBSE": {
    Science: ["Physics", "Chemistry", "Biology", "Mathematics", "English"],
    Commerce: [
      "Accountancy",
      "Business Studies",
      "Economics",
      "Mathematics",
      "English",
      "Entrepreneurship",
    ],
    "Arts/Humanities": [
      "History",
      "Geography",
      "Political Science",
      "Economics",
      "Sociology",
      "Psychology",
      "English",
      "Hindi",
      "English Literature",
    ],
    "Vocational (Optional)": [
      "Computer Science",
      "Agriculture",
      "Home Science",
      "Physical Education",
    ],
  },

  "Sikkim - SBSE": {
    Science: [
      "Physics",
      "Chemistry",
      "Mathematics",
      "Biology",
      "Computer Science",
      "English",
    ],
    Commerce: [
      "Accountancy",
      "Business Studies",
      "Economics",
      "Mathematics",
      "Informatics Practices",
      "English",
      "Business Mathematics and Basic Statistics",
    ],
    "Humanities/Arts": [
      "History",
      "Political Science",
      "Economics",
      "Geography",
      "Psychology",
      "Sociology",
      "English",
      "Regional Languages",
      "Law",
      "Justice & Governance",
      "Tourism",
      "Entrepreneurship",
      "Media And Communication Studies",
    ],
  },

  "Tamil Nadu - TNBSE": {
    Science: [
      "Physics",
      "Chemistry",
      "Mathematics",
      "Biology",
      "Economics",
      "Computer Science",
      "Home Science",
    ],
    Commerce: [
      "Economics",
      "Accountancy",
      "Statistics",
      "Business Studies",
      "Mathematics",
      "Informatics Practices",
    ],
    Arts: [
      "History",
      "Geography",
      "Political Science",
      "Philosophy",
      "Psychology",
      "Hindi",
      "Other Regional Languages",
      "Sociology",
      "Physical Education",
      "Art",
      "Music",
    ],
    Vocational: [
      "Hospitality and Tourism",
      "Retail Management",
      "Information Technology",
      "Automotive Technology",
      "Healthcare Services",
      "Agriculture",
      "Fashion Designing",
      "Beauty and Wellness",
      "Media and Entertainment",
    ],
  },

  "Telangana - BSET": {
    Science: [
      "Mathematics IIA",
      "Mathematics IIB",
      "Physics",
      "Chemistry",
      "Botany",
      "Zoology",
      "Bridge Course Maths",
    ],
    Commerce: ["Commerce", "Economics"],
    "Arts/Humanities": [
      "Civics",
      "History",
      "Psychology",
      "Geography",
      "Geology",
      "Logic",
      "Public Administration",
      "Sociology",
      "Modern Languages",
    ],
  },

  "Tripura - TBSE": {
    Science: ["Physics", "Chemistry", "Biology", "Mathematics"],
    Commerce: ["Accountancy", "Business Studies", "Economics"],
    Arts: [
      "History",
      "Geography",
      "Political Science",
      "Philosophy",
      "Music",
      "Mizo",
      "Kokborok",
      "Hindi",
      "English",
      "Education",
      "Sociology",
    ],
    Vocational: [
      "Agriculture (Gardener, Dairy Farmer)",
      "IT-ITeS",
      "Electronics and Hardware",
      "Tourism",
      "Automotive",
    ],
  },

  "Uttar Pradesh - UPMSP": {
    Science: ["Physics", "Chemistry", "Mathematics", "Biology"],
    Commerce: ["Accountancy", "Business Studies", "Commerce"],
    "Arts/Humanities": [
      "History",
      "Geography",
      "Civics",
      "Economics",
      "Sociology",
      "Drawing",
      "Home Science",
      "Hindi",
      "English",
      "Punjabi",
      "Nepali",
      "Sanskrit",
      "Pali",
      "Arabic",
      "Parsi",
      "Sangeet (Gayan - Vocal Music)",
      "Sangeet (Vadan - Instrumental Music)",
      "Agriculture",
      "Computer",
      "Painting",
    ],
  },

  "Uttarakhand - UBSE": {
    Science: ["Physics", "Chemistry", "Mathematics", "Biology"],
    Commerce: ["Accountancy", "Business Studies", "Economics"],
    "Arts/Humanities": [
      "History",
      "Geography",
      "Political Science",
      "Economics",
      "Home Science",
    ],
  },

  "West Bengal - WBBSE (WBCHSE)": {
    Science: [
      "Physics",
      "Chemistry",
      "Biology",
      "Mathematics",
      "Computer Science",
      "Computer Applications",
      "Environmental Science",
      "Artificial Intelligence and Data Science (AIDS)",
      "Fisheries and Aquaculture (FSAQ)",
    ],
    Commerce: [
      "Accountancy",
      "Business Studies",
      "Economics",
      "Business Mathematics and Basic Statistics (BMBS)",
    ],
    "Arts/Humanities": [
      "History",
      "Geography",
      "Political Science",
      "Economics",
      "Basic Mathematics for Social Sciences (BMSS)",
      "Environmental Science",
    ],
  },
};

export { seniorSecondaryBoards };
